// extracted by mini-css-extract-plugin
export default {"Donate":"holiday_Donate__czx3e","DonateInner":"holiday_DonateInner__unNhX","productInCartNumber":"holiday_productInCartNumber__DInoy"};